import { useRef, useState } from "react";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";

import {
  getCategoryTitle,
  getInheritedConsentInfo,
} from "../utils/competitors.utils";

const UploadConsentModal = ({
  show,
  registration,
  categories = [],
  uploading = false,
  error = "",
  onClose,
  onSubmit,
}) => {
  const inputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [localError, setLocalError] = useState("");

  const consent = registration
    ? getInheritedConsentInfo(registration, categories)
    : null;

  const handleClose = () => {
    if (uploading) return;
    setFile(null);
    setLocalError("");
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!file) {
      setLocalError("Select a signed consent document to upload.");
      return;
    }
    if (!consent?.categoryId) {
      setLocalError("Category is missing for this registration.");
      return;
    }
    onSubmit({ categoryId: consent.categoryId, file });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton={!uploading}>
          <Modal.Title>Upload signed consent</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {registration ? (
            <p className="text-muted mb-3">
              Category:{" "}
              <strong>{getCategoryTitle(registration)}</strong>
              {consent?.isSigned ? (
                <span className="ms-2 badge bg-success">Already signed</span>
              ) : null}
            </p>
          ) : null}

          <p className="small text-muted mb-3">
            Signed consent is stored on the category. All registrations in this
            category will show as signed after upload.
          </p>

          <Form.Group>
            <Form.Label>Signed consent document</Form.Label>
            <Form.Control
              ref={inputRef}
              type="file"
              accept=".pdf,.png,.jpg,.jpeg,.webp,.doc,.docx,application/pdf,image/*"
              disabled={uploading}
              onChange={(e) => {
                setFile(e.target.files?.[0] || null);
                setLocalError("");
              }}
            />
            {file ? (
              <Form.Text className="text-muted d-block mt-1">
                Selected: {file.name}
              </Form.Text>
            ) : null}
          </Form.Group>

          {(localError || error) && (
            <Alert variant="danger" className="mt-3 mb-0">
              {localError || error}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            variant="outline-secondary"
            onClick={handleClose}
            disabled={uploading}
          >
            Cancel
          </Button>
          <Button type="submit" disabled={uploading || !consent?.categoryId}>
            {uploading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Uploading...
              </>
            ) : (
              "Upload"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UploadConsentModal;
